import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspacePluginCollaboratorSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { accountOrTeamId, collaboratorType, pluginId, permissionLevel } = action;

  const workspacePluginPermissionGrant = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_PERMISSION_GRANT,
    [`${collaboratorType}Id`]: accountOrTeamId,
    pluginId,
    permissionLevel,
  });

  if (workspacePluginPermissionGrant.type === constants.RTM_WORKSPACE_PLUGIN_PERMISSION_GRANT_OK) {
    yield put(commandWorkspacePluginCollaboratorSummary(pluginId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspacePluginPermissionGrant.message || <FormattedMessage {...messages.permissionGrantError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_PERMISSION_GRANT, catchErrors, sendRequest, connection);
}
